import { useMemo, useState } from 'react';
export const useWindowTabs = ({ tabs = [], activeTabId: _activeTabId }) => {
    const [selectedDate, setSelectedDate] = useState();
    const [windowTabs, setWindowTabs] = useState(tabs);
    const [activeTabId, setActiveTabId] = useState(_activeTabId ?? '');
    const activeTab = useMemo(() => {
        return windowTabs[windowTabs.map((tab) => tab.id).indexOf(activeTabId)];
    }, [activeTabId]);
    const addWindowTab = (tab) => {
        // Add tab to array
        if (!windowTabs.map((tab) => tab.id).includes(tab.id)) {
            setWindowTabs((prev) => [...prev, tab]);
        }
        // Swap activeTabId
        setActiveTabId(tab.id);
    };
    const closeWindowTab = (id) => {
        setWindowTabs((prev) => {
            const _new = [...prev];
            const tabIds = _new.map((tab) => tab.id);
            const indexOfClosed = tabIds.indexOf(id);
            // If we close the active tab, move one left, if possible
            if (activeTabId === id) {
                if (prev.length >= 1) {
                    const prevTab = prev[indexOfClosed - 1];
                    setActiveTabId(prevTab.id);
                }
            }
            _new.splice(tabIds.indexOf(id), 1);
            return _new;
        });
    };
    return {
        selectedDate,
        setSelectedDate,
        windowTabs,
        activeTab,
        activeTabId,
        setActiveTabId,
        addWindowTab,
        closeWindowTab,
    };
};
